// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"89b598dc","856":"fdd2ec73"}[chunkId] + ".js";
};